import { Reducer } from 'redux';
import { DevicesInterface } from './types';

export const DevicesInitialState: DevicesInterface = {
    userAgent: null,
    loading: false,
    campaigns: null,
    channels: null,
    //userAgentStats: null
}

const reducer: Reducer<DevicesInterface> = (state: DevicesInterface = DevicesInitialState, action): DevicesInterface => {
    switch(action.type) {
        case "@@devices/FETCH_START":
        case "@@devices/FETCH_SUCCESS":
        case "@@devices/FETCH_ERROR":
            return { ...state, ...action.payload }
        case "@@allcampaigns/FETCH_START":
        case "@@allcampaigns/FETCH_SUCCESS":
        case "@@allcampaigns/FETCH_ERROR":
            return { ...state, ...action.payload }
        case "@@allchannels/FETCH_START":
        case "@@allchannels/FETCH_SUCCESS":
        case "@@allchannels/FETCH_ERROR":
            return { ...state, ...action.payload }
        case "@@deviceschannel/FETCH_START":
        case "@@deviceschannel/FETCH_SUCCESS":
        case "@@deviceschannel/FETCH_ERROR":
            return { ...state, ...action.payload }
        default:
            return state;
    }
}

export { reducer as devices };

export default reducer;
